export default __webpack_public_path__ + "static/media/ico_8.f6a3eb18.png";